const { h, render, Component } = require('preact');

class CommonStatus extends Component {
  constructor() {
    super();
  }
  render({label,value}) {
    return (<div class='date-info'>
              <span>{label} {value}</span>
            </div>)
  }
}
module.exports = CommonStatus
